import { ISpecialAssessment } from '../special-assessments';

export const SPECIAL_ASSESSMENT_INLINE_THRESHOLD = 5;

export const SPECIAL_ASSESSMENT_SCHEDULE_ROWS_PER_PAGE = 30;

export const DEFAULT_SPECIAL_ASSESSMENT_NAME = 'Special Assessment';

export interface ISpecialAssessmentDisplayRow {
    id: string;
    year: number;
    name: string;
    hasName: boolean;
    amount: number;
    clientRequested: boolean;
    title: string;
}

export interface ISpecialAssessmentPresentation {
    rows: ISpecialAssessmentDisplayRow[];
    companyRows: ISpecialAssessmentDisplayRow[];
    clientRows: ISpecialAssessmentDisplayRow[];
    companyTotal: number;
    clientTotal: number;
    showInline: boolean;
}

export const getSpecialAssessmentTitle = (row: ISpecialAssessment): string => {
    const name = (row.name || '').trim();
    return `Special Assessment${name ? ` \u2013 ${name}` : ''} (FY ${row.year})`;
};

export const getSpecialAssessmentPresentation = (
    rows: ISpecialAssessment[],
    threshold: number = SPECIAL_ASSESSMENT_INLINE_THRESHOLD,
): ISpecialAssessmentPresentation => {
    const display = (rows || [])
        .map((row, index) => ({ row, index }))
        .sort((a, b) => (a.row.year - b.row.year)
            || (Number(a.row.clientRequested) - Number(b.row.clientRequested))
            || (a.index - b.index))
        .map(({ row }): ISpecialAssessmentDisplayRow => {
            const name = (row.name || '').trim();
            return {
                id: row.id,
                year: row.year,
                name: name || DEFAULT_SPECIAL_ASSESSMENT_NAME,
                hasName: !!name,
                amount: row.amount,
                clientRequested: row.clientRequested,
                title: getSpecialAssessmentTitle(row),
            };
        });

    const companyRows = display.filter((row) => !row.clientRequested);
    const clientRows = display.filter((row) => row.clientRequested);
    const total = (list: ISpecialAssessmentDisplayRow[]) => list.reduce((sum, row) => sum + row.amount, 0);

    return {
        rows: display,
        companyRows,
        clientRows,
        companyTotal: total(companyRows),
        clientTotal: total(clientRows),
        showInline: display.length <= threshold,
    };
};



// WEBPACK FOOTER //
// ./src/report/pdf/special-assessments-presentation.ts